import { render, staticRenderFns } from "./MotorLifeCycle.vue?vue&type=template&id=39ce8b70&"
import script from "./MotorLifeCycle.vue?vue&type=script&lang=js&"
export * from "./MotorLifeCycle.vue?vue&type=script&lang=js&"
import style0 from "./MotorLifeCycle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorLifeCycle.vue"
export default component.exports